import styled from 'styled-components';

export const Base = styled.div`
	height: 100vh; /* fallback for older browsers */
	height: 100svh; /* small viewport height - excludes dynamic UI */
	width: -webkit-fill-available;
	width: -moz-available;
	width: stretch;
	position: absolute;
	background: ${(p) => p.theme.white};
	overflow-x: hidden;
	display: flex;
	flex-direction: column;
`;

export const SidebarToggle = styled.div`
	position: absolute; /* this is sticky. if we want it to not scroll with the container, set position to fixed. on mobile, it seems it definitely should scroll with the container. on desktop i'm on the fence -- scrolling feels good on narrow screens, but not on wide ones */
	top: 10px;
	left: 10px;
	z-index: 1;
`;

export const Container = styled.div`
	position: relative;
	width: 100%;
	margin: 0 auto;
	padding: 10px 20px;
	flex: 1;
	overflow-y: auto;
	box-sizing: border-box;
`;

export const SubscriptionSection = styled.div`
	padding-top: 100px;
	max-width: 640px;
	margin: 0 auto;
	text-align: center;
`;

export const SectionHeadline = styled.h1`
	font-size: 28px;
	font-weight: 700;
	margin-bottom: 8px;
	color: ${(p) => p.theme.gray[1000]};

	@media (max-width: 768px) {
		font-size: 24px;
	}
`;

export const SectionSubheading = styled.p`
	font-size: 16px;
	color: ${(p) => p.theme.gray[600]};
	margin-bottom: 32px;
`;

export const PricingToggleWrapper = styled.div`
	margin-bottom: 40px;
	display: flex;
	justify-content: center;
`;

export const PricingToggle = styled.div`
	position: relative;
	background: ${(p) => p.theme.gray[0]};
	border-radius: 24px;
	padding: 4px;
	display: inline-flex;
	gap: 4px;

	@media (max-width: 768px) {
		width: 100%;
	}
`;

export const ToggleOption = styled.div<{ active: boolean }>`
	position: relative;
	z-index: 2;
	padding: 10px 32px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: color 0.3s ease;
	border-radius: 20px;
	color: ${(p) => (p.active ? p.theme.gray[1000] : p.theme.gray[600])};

	@media (max-width: 768px) {
		flex: 1;
		text-align: center;
	}
`;

export const ToggleIndicator = styled.div<{ isYearly: boolean }>`
	position: absolute;
	top: 4px;
	left: 4px;
	width: calc(50% - 4px);
	height: calc(100% - 8px);
	background: ${(p) => p.theme.gray[200]};
	border-radius: 20px;
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	z-index: 1;
	transform: ${(p) => (p.isYearly ? 'translateX(100%)' : 'translateX(0)')};
`;

export const TierCards = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 32px;
	margin-bottom: 48px;
	max-width: 700px;
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 24px;
	}
`;

export const PricingLinkWrapper = styled.div`
	text-align: center;
	margin-bottom: 48px;
`;

export const PricingLink = styled.a`
	display: inline-block;
	color: ${(p) => p.theme.blue[500]};
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	transition: color 0.2s ease-in-out;
	cursor: pointer;

	&:hover {
		color: ${(p) => p.theme.blue[600]};
	}
`;

export const AccountFooter = styled.div`
	flex-shrink: 0;
	background: ${(p) => p.theme.gray[0]};
	border-top: 1px solid ${(p) => p.theme.gray[200]};
	padding: 20px;
	padding-left: 26px;
	padding-right: 26px;
	z-index: 100;
`;

export const AccountFooterContent = styled.div`
	max-width: 1190px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 24px;
`;

export const DisplayNameEdit = styled.button<{ hide: boolean }>`
	display: ${(p) => (p.hide ? 'none' : 'flex')};
	align-items: center;
	gap: 8px;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	padding: 4px 8px;
	margin-left: -8px;
	border-radius: 6px;
	background: transparent;
	border: none;
	font-family: inherit;

	&:hover {
		background: rgba(30, 144, 255, 0.1);
	}
`;

export const DisplayNameText = styled.span`
	font-size: 16px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
`;

export const EditIcon = styled.div`
	display: flex;
	align-items: center;
`;

export const AccountEmail = styled.span<{ hide: boolean }>`
	display: ${(p) => (p.hide ? 'none' : 'block')};
	color: ${(p) => p.theme.gray[600]};
	font-size: 14px;
	user-select: text;
	cursor: text;
`;

export const AccountLogout = styled.button`
	color: ${(p) => p.theme.gray[600]};
	text-decoration: none;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	background: transparent;
	border: none;
	font-family: inherit;
	transition: color 0.2s ease-in-out;

	&:hover {
		color: ${(p) => p.theme.gray[400]};
	}
`;
